<template>
  <div>
    <div class="text-center titles font-weight-bold">
      აირჩიე ვიზიტის დრო
    </div>
    <div class="text-center small text-danger" v-if="$v.time.$error">გთხოვთ აირჩიოთ სასურველი დრო</div>
    <div class="d-flex justify-content-center mt-2">
      <b-card class="pl-3 pr-3 pt-3 pb-0">
        <b-row>
          <b-col cols="4" class="text-center mb-3 p-0" v-for="(t,index) in times.times " :key="index">
            <div href="#" class="btn NotoSans-Regular" v-bind:class="{ 'btn-success': time ===t }"
               @click="time=t">
              {{t}}
            </div>
          </b-col>
        </b-row>

      </b-card>
    </div>
  </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";
export default {
  name: "step-6",
  props:['times', 'form'],
  data() {
    return {
      time: null,
    }
  },
  validations:{ time:{required} },
  
}
</script>

<style scoped>
.card {
  border-radius: 10px !important;
  box-shadow: 0 0 3px #899BB1;
}

.btn {
  border-radius: 20px !important;
  padding: 2px 10px !important;
}

.btn.focus, .btn:focus {
  box-shadow: 0 0 0 !important;
}
.NotoSans-Regular{
  font-size: 14px!important;
}
.btn-success{
  border-color: unset !important;
}
</style>